/**
 * Opaque revision used to invalidate admin-credential-dependent work without
 * putting a credential (or a credential-derived value) into scheduler state.
 */
export const ADMIN_CREDENTIAL_REVISION_STORAGE_KEY = 'adminCredentialRevisionV1';

const createRevision = (): string =>
  globalThis.crypto?.randomUUID?.()
  ?? `${Date.now()}-${Math.random().toString(36).slice(2)}`;

export const readAdminCredentialRevision = (): string => {
  try {
    return localStorage.getItem(ADMIN_CREDENTIAL_REVISION_STORAGE_KEY) ?? 'initial';
  } catch {
    return 'initial';
  }
};

export const markAdminCredentialChanged = (): string => {
  const revision = createRevision();
  try {
    localStorage.setItem(ADMIN_CREDENTIAL_REVISION_STORAGE_KEY, revision);
  } catch {
    // The credential storage operation itself reports failure separately. This
    // helper deliberately never exposes or derives state from the credential.
  }
  return revision;
};
